import translations from './translations';

const translate = (key, language) => {
  return translations[language][key] || key;
};

export default translate;
